export const APP_CONFIG = {

    MENU_ID: 'primerMenu',
    CONTENT_ID: 'principal',
    PAGES: {

        HOME: {
            path: '/home',
            title: 'ScanClub',
            showMenuButton: true, // Determina si se muestra el icono de la hamburguesa
            permissions: ['ui:transactions:read'],
            actions: {
                download: ['ui:transactions:report']
            },
            messages: {
                error: {
                    download: 'Ha ocurrido un error. Volvé a intentar'
                }
            }
        },
        LOGIN: {
            path: '/login',
            nextPage: '/qr-scan',
            rules: {
                inputs: {
                    username: {
                        required: {
                            value: true,
                            message: "El campo es requerido"
                        },
                        maxLength: {
                            value: 50,
                            message: "Se requieren máximo 50 caracteres"
                        },
                        // minLength: {
                        //     value: 3,
                        //     message: "Se requieren mínimo 3 caracteres"
                        // }, //Redundante ante el patrón de validación de email
                        pattern: {
                            value: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
                            message: "Debes ingresar un email válido"
                        }
                    },
                    password: {
                        required: {
                            value: true,
                            message: "El campo es requerido"
                        },
                        maxLength: {
                            value: 50,
                            message: "Se requieren máximo 50 caracteres"
                        },
                        minLength: {
                            value: 3,
                            message: "Se requieren mínimo 3 caracteres"
                        }
                    }
                }
            }
        },
        RESET_PASSWORD: {
            path: '/reset-password',
            nextPage: '/login',
            rules: {
                inputs: {
                    email: {
                        required: {
                            value: true,
                            message: "El campo es requerido"
                        },
                        maxLength: {
                            value: 50,
                            message: "Se requieren máximo 50 caracteres"
                        },
                        minLength: {
                            value: 3,
                            message: "Se requieren mínimo 3 caracteres"
                        },
                        pattern: {
                            value: "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$",
                            message: "El formato del email es inválido"
                        }
                    }
                }
            }
        },
        QR_SCAN: {
            path: '/qr-scan',
            title: 'Escanear QR',
            showMenuButton: true, // Determina si se muestra el icono de la hamburguesa
            prevPage: '/qr-scan',
            nextPage: '/detail',
            platformRedirectPage: '/document', // Página necesaria para redirigir en caso de correr en web
            messages: {
                error: {
                    notFunctionWeb: 'Funcionalidad únicamente disponible en APP',
                }
            },
            permissions: ['ui:transactions:write:qr']
        },
        DOCUMENT: {
            path: '/document',
            title: 'Ingresar DNI',
            showMenuButton: true,
            prevPage: '/document',
            nextPage: '/detail',
            rules: {
                inputs: {
                    document: {
                        required: {
                            value: true,
                            message: "Por favor ingrese un DNI"
                        },
                        min: {
                            value: 1000000,
                            message: "Se requieren mínimo 7 caracteres"
                        },
                        max: {
                            value: 99999999,
                            message: "Se requieren máximo 8 caracteres"
                        }
                    }
                }
            },
            permissions: ['ui:transactions:write:document']
        },
        BENEFIT: {
            path: '/benefit',
            title: 'Beneficios disponibles',
            showMenuButton: false,
            prevPage: '/qr-scan',
            nextPage: '/detail',
            messages: {
                error: {
                    notFoundBenefits: 'No hay beneficios disponibles',
                }
            },
            validate: {

                benefitsLength: 1
            },
            permissions: ['ui:transactions:write:qr', 'ui:transactions:write:document']
        },
        DETAIL: {
            path: '/detail',
            title: 'Detalle de transacción',
            showMenuButton: false,
            nextPage: '/qr-scan',
            prevPage: '/qr-scan',
            messages: {
                error: {
                    notFoundTransaction: 'No se encontró la transacción',
                },
                info: {
                    name: 'No disponible'
                }
            },
            validate: {

                transactionId: 0, // Valor indebido para una transacción en esta página
                transactionStatus: [100] // Valores para determinar si se habilita la edición del importe o la cancelación de la transacción
            },
            rules: {
                inputs: {
                    amount: {
                        required: {
                            value: true,
                            message: "Se requiere el monto bruto de la operación"
                        },
                        min: {
                            value: 1,
                            message: "El importe deberá ser mayor a $1"
                        },
                        max: {
                            value: 9999999.99,
                            message: "El importe no deberá ser mayor a $9.999.999,99"
                        },
                        maxDecimals: {
                            value: 2,
                            message: "El importe no deberá superar los 2 decimales"
                        }
                    }
                }
            },
            permissions: ['ui:transactions:write:qr', 'ui:transactions:write:document', 'ui:transactions:read']
        },
        HISTORY: {
            path: '/history',
            title: 'Historial',
            showMenuButton: false,
            fabButton: {
                scrollFabHeight: 500
            },
            nextPage: '/detail',
            ref: 'history', //Especifica la referencia que usará para redux en esta página, al momento de pasar al detalle
            messages: {
                error: {
                    emptyResult: 'No hay más transacciones disponibles',
                }
            },
            permissions: ['ui:transactions:read']
        },
        CONTACT: {
            path: '/contact',
            title: 'Contacto',
            showMenuButton: false,
            redirectToSuccess: '/',
            redirectToError: '/contact',
            rules: {
                inputs: {
                    name: {
                        required: {
                            value: true,
                            message: "El establecimiento debe contener al menos 3 caracteres"
                        },
                        maxLength: {
                            value: 50,
                            message: "El establecimiento puede contener hasta 50 caracteres"
                        },
                        minLength: {
                            value: 3,
                            message: "El establecimiento debe contener al menos 3 caracteres"
                        }
                    },
                    message: {
                        required: {
                            value: true,
                            message: "El mensaje debe contener al menos 15 caracteres"
                        },
                        maxLength: {
                            value: 500,
                            message: "El mensaje puede contener hasta 500 caracteres"
                        },
                        minLength: {
                            value: 15,
                            message: "El mensaje debe contener al menos 15 caracteres"
                        }
                    }
                }
            },
            attributes: {

                message: {
                    rows: 8,
                    placeholder: 'Escribí tu mensaje...'
                }
            },
            permissions: ['ui:message:write']
        },
        MAINTEINMENT: {
            path: '/mainteinment'
        },
        NOT_AUTHORIZED: {
            path: '/notAuthorized'
        },
        OFFLINE: {
            path: '/offline',
            title: 'Dispositivo sin conexión',
			message: 'Ha ocurrido un error. Revisá tu conexión'
        },
        REDIRECT: {
            mobile: '/qr-scan',
            web: '/document'
        }
    },
    LOGOUTREF: '/login',
    STORAGE: {
        KEYS: {

            USER: 'profile',
            PAGE_INIT: 'pageInit',
            VERSION: 'version',
            MAINTEINMENT: 'mainteinment',
            MODAL: 'modal',
            NETWORK: 'network'
        }
    },
    API: {
        AUTH: {
            USER_INFO: {
                METADATA_PREFIX: 'https://lanacion.com.ar/account', // Es el prefijo que auth0 le asigna a la key de la metadata del usuario
            },
            LOGIN: '/oauth/token',
            AUTHENTICATED: '/security/auth',
            REFRESH_TOKEN: '/security/token2',
            REFRESH_TOKEN_REJECT: '/security/token/reject',
            FORGOT_PASSWORD: '/dbconnections/change_password',
            MESSAGES: {
                ERROR: {
                    userBlocked: 'user is blocked',
                    incorrectUserOrPass: 'Wrong email or password.',
                    userNotVerified: 'Please verify your email before logging in.',
                    tooManyAttempts: `Your account has been blocked after multiple consecutive login attempts. We've sent you an email with instructions on how to unblock it.`
                }
            },
            STATUS_CODE: { 
                401: {
                    MESSAGE: 'El usuario está bloqueado'
                },
                403: {
                    MESSAGE: 'Email o contraseña incorrectos'
                },
                412: {
                    MESSAGE: 'Verificá el email en tu casilla antes de loguearte'
                },
                429: {
                    MESSAGE: 'Usuario bloqueado por demasiados intentos de acceso incorrectos'
                },
                500: {
                    MESSAGE: 'Ha ocurrido un error. Volvé a intentar'
                }
            }
        },
        VIRTUAL_CREDENTIAL: {

            HISTORY: '/transactions',
            TRANSACTION: '/transactions',
            BENEFITS: '/benefits',
            SETTINGS: '/configurations',
            METADATA: '/transactions/metadata',
            FILES: '/transactions/report',
            CONTACT: '/contacts',
            STATUS_CODE: { // Necesario para mapear los errores con la API de cara al usuario
                200: {
                    MESSAGE: 'OK!'
                },
                400: {
                    MESSAGE: 'Ha ocurrido un error. Volvé a intentar'
                },
                401: {
                    MESSAGE: 'Ha ocurrido un error. Volvé a intentar'
                },
                403: {
                    MESSAGE: 'Ha ocurrido un error. Volvé a intentar'
                },
                404: {
                    MESSAGE: 'El DNI ingresado no posee una suscripción activa'
                },
                409: {
                    MESSAGE: 'Ha ocurrido un error. Volvé a intentar'
                },
                500: {
                    MESSAGE: 'Ha ocurrido un error. Volvé a intentar'
                }
            },
            STATUS_CODE_TRANSACTION: { // Necesario para mapear los estados de una transacción de cara al usuario
                100: {
                    DESCRIPTION: 'Pendiente',
                    COLOR: 'warning',
                    ICON: 'alertSharp'
                },
                200: {
                    DESCRIPTION: 'Rechazada',
                    COLOR: 'danger',
                    ICON: 'closeSharp'
                },
                300: {
                    DESCRIPTION: 'Confirmada',
                    COLOR: 'success',
                    ICON: 'checkmarkSharp'
                },
                400: {
                    DESCRIPTION: 'Cancelada',
                    COLOR: 'danger',
                    ICON: 'closeSharp'
                },
                500: {
                    DESCRIPTION: 'Expirada',
                    COLOR: 'medium',
                    ICON: 'alertSharp'
                }
            },
            TRANSACTION_METADATA: 300,
            SUCCESS_CODE: [100, 200], //Indica los posibles códigos de success
            ERROR_CODE: [300, 400, 401, 403, 409, 500], //Indica los posibles códigos de error,
            ERROR_CODE_TOAST: [404, 500],
            //Indica los posibles códigos de rechazo,
            INVALID_CODE: {
                200: { MESSAGE: 'El suscriptor no está activo' },
                201: { MESSAGE: 'El beneficio no es válido' },
                202: { MESSAGE: 'El beneficio no corresponde al comercio' },
                203: { MESSAGE: 'El beneficio no está vigente' },
                204: { MESSAGE: 'El beneficio no aplica hoy' },
                205: { MESSAGE: 'El beneficio no es válido para socios [X]' },
                206: { MESSAGE: 'El beneficio no corresponde al comercio' }
            }, //Indica los posibles códigos de rechazo con sus respectivos mensajes            
            APPROVED_CODE: 300, // código necesario para aprobar una transación
            CANCELLED_CODE: 400 // código necesario para cancelar una transación
        }
    },
    GUARDS: {
        AUTH: {
            TIME_START: 1000,
            TIME_INTERVAL: 2000,
            REFRESH_TOKEN: true
        }
    },
    CONTROLS: {
        INFINITE_SCROLL: {
            SHOWIN: '150px',
            LOADING_SPINNER: 'crescent',
            LOADING_TEXT: 'Aguardá un momento por favor...'
        },
        TOAST: {
            DURATION: 4500,
            POSITION: 'bottom'
        },
        LOADING: {

            MESSAGE: 'Aguardá un momento por favor...'
        },
        SCAN: {
            FORMATS: ['QR_CODE'], //'QR_CODE' | 'DATA_MATRIX' | 'UPC_E' | 'UPC_A' | 'EAN_8' | 'EAN_13' | 'CODE_128' | 'CODE_39' | 'CODE_93' | 'CODABAR' | 'ITF' | 'RSS14' | 'RSS_EXPANDED' | 'PDF_417' | 'AZTEC' | 'MSI'
        }
    },
    PAGINATION: {
        MOBILE: {
            PAGE: 1,
            SIZE: 10
        },
        WEB: {
            PAGE: 1,
            SIZE: 20
        }
    },
    SPLASH: {
        WEB: {
            ACTIVE: false,
            TIME_HIDE: 5000
        },
        MOBILE: {
            ACTIVE: true,
            TIME_HIDE: 5000
        },
    },

    APP: {
        ANDROID: {
            APPID: 'com.lanacion.scanclub'
        },
        IOS: {
            APPID: '1545379549'
        }
    },

    // VERSION: { // TODO: quitarlo porque sólo tiene sentido que la devuelva el gonogo

    //     ANDROID: {

    //         title: 'Actualización disponible',
    //         message: "Se instalará la nueva versión.",
    //         currentVersion: "1.0"
    //     },
    //     IOS: {

    //         title: 'Actualización disponible',
    //         message: "Se instalará la nueva versión.",
    //         currentVersion: "1.0"
    //     },
    //     title: "Actualización instalada",
    //     message: "Se ha realizado una actualización.",
    //     currentVersion: "1.0"
    // },

    MESSAGE: {

        ALERT: {

            // mainteinment: { // TODO: quitarlo porque sólo tiene sentido que la devuelva el gonogo
            //     title: "APP en mantenimiento",
            //     message: "No estamos disponibles en este momento. Volvé a intentar en unos minutos.",
            //     enabled: false
            // },

            resetPassword: {
                title: "Revisa tu email",
                message: "Se te envió un email a tu casilla."
            }
        },

        INFO: {

            permissions: {
                title: 'No Autorizado',
                message: 'Por favor, solicitá tus permisos de uso a través del formulario de contacto.'
            }
        }
    },

    ANALYTICS: {

        EVENTS: {
            LOGIN: {
                CATEGORY: 'Login',
                ACTIONS: {
                    LOGIN: 'iniciar_sesion'
                }
            },
            RECOVER_PASSWORD: {
                CATEGORY: 'Recupero password',
                ACTIONS: {
                    RECOVER_PASSWORD: 'recuperar_clave'
                }
            },
            MENU: {
                CATEGORY: 'Menú',
                ACTIONS: {
                    HOME: 'inicio',
                    QR: 'escanear_qr',
                    DNI: 'ingresar_dni',
                    HISTORY: 'historial',
                    CONTACT: 'contacto',
                    LOGOUT: 'cerrar_sesion'
                }
            },
            HOME: {
                CATEGORY: 'Pantalla Inicio',
                ACTIONS: {
                    DOWNLOAD: 'download'
                },
                LABELS: {
                    DOWNLOAD: 'archivo_descargado_ok'
                }
            },
            QR_PAGE: {
                CATEGORY: 'Pantalla Escaneo QR',
                ACTIONS: {
                    SCAN_QR: 'cta_escanear_qr'
                },
                LABELS: {
                    SCAN_QR: 'qr_escaneado_ok'
                }
            },
            DNI_PAGE: {
                CATEGORY: 'Pantalla Ingresar DNI',
                ACTIONS: {
                    CONTINUE: 'cta_continuar'
                }
            },
            CONTACT_PAGE: {
                CATEGORY: 'Formulario de contacto',
                ACTIONS: {
                    SEND: 'cta_enviar_consulta'
                }
            },
            DETAIL_PAGE: {
                CATEGORY: 'Detalle de transacción',
                ACTIONS: {
                    CONFIRM: 'cta_confirmar',
                    CANCEL: 'cta_cancelar'
                }
            },
            TRANSACTION: {
                CATEGORY: 'Transacción OK',
                ACTIONS: {
                    NEW_TRANSACTION: 'cta_generar_nueva_transaccion'
                }
            }
            
        }
    }
};